import { cva } from "@msuite/ui/libs/cva";
import { cn } from "@msuite/ui/utils";
import type { Enums } from "@msuite/utils/types";

/** Props Interface */
interface TicketActionBarButtonProps {
	color: Extract<Enums<"color">, "blue" | "red" | "amber" | "emerald">;
	isDisabled?: boolean;
}

export function TicketActionBarButton({ color, isDisabled }: TicketActionBarButtonProps) {
	/** Computed */
	const classes = ticketActionBarButton({ color, isDisabled });

	/** Render */
	return (
		<button
			type="button"
			className={cn("w-3 h-3 rounded-md", "cursor-pointer", classes)}
			disabled={isDisabled}
		/>
	);
}

const ticketActionBarButton = cva(["bg-primary-200 dark:bg-primary-700 active:brightness-90"], {
	variants: {
		color: {
			blue: ["hover:bg-blue-400 dark:hover:bg-blue-600"],
			red: ["hover:bg-red-400 dark:hover:bg-red-600"],
			amber: ["hover:bg-amber-400 dark:hover:bg-amber-600"],
			emerald: ["hover:bg-emerald-500 dark:hover:bg-emerald-600"],
		},
		isDisabled: {
			false: [],
			true: ["!cursor-not-allowed", "!opacity-50"],
		},
	},
});
